
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import axios from "axios";

export default function AddEditTestimonial() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = Boolean(id);

  const [deleteId, setDeleteId] = useState(null);

  const [form, setForm] = useState({
    imageUrl: "",
    name: "",
    position: "",
    testimonial: "",
  });

  /* 🔹 FETCH DATA FOR EDIT */
  useEffect(() => {
    if (!id) return;

    axios
      .get(`https://api.livestockify.com/api/admin/testimonials/${id}`)
      .then((res) => {
        const data = res.data;
        setForm({
          imageUrl: data.imageUrl || data.image || "",
          name: data.name || "",
          position: data.position || "",
          testimonial: data.description || "",
        });
      })
      .catch((err) => console.error("Edit fetch error:", err));
  }, [id]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  /* 🔹 ADD / UPDATE */
  const handleSubmit = async () => {
    try {
      if (isEdit) {
        await axios.put(
          `https://api.livestockify.com/api/admin/testimonials/${id}`,
          form
        );
      } else {
        await axios.post(
          "https://api.livestockify.com/api/admin/testimonials",
          form
        );
      }
      navigate("/uploads/testimonials");
    } catch (error) {
      console.error("API Error:", error.response?.data || error);
      alert("Failed to save testimonial");
    }
  };



  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      {/* CONTENT */}
      <div className="flex-1 bg-white rounded-l-2xl p-4 md:p-8 md:pl-14 pl-4 flex justify-center">
        <div className="w-full max-w-3xl">
          {/* HEADING */}
          <h1 className="text-lg font-semibold text-green-700 mb-8 text-center">
            {isEdit ? "Edit Testimonial" : "Add Testimonial"}
          </h1>

          {/* FORM */}
          <div className="space-y-6">
            {[
              ["Image URL", "imageUrl"],
              ["Name", "name"],
              ["Position", "position"],
            ].map(([label, name]) => (
              <div
                key={name}
                className="grid grid-cols-1 sm:grid-cols-[150px_1fr] gap-4 items-center"
              >
                <label className="text-sm font-medium text-left sm:text-right">
                  {label}
                </label>
                <input
                  name={name}
                  value={form[name]}
                  onChange={handleChange}
                  className="w-full max-w-[420px] border rounded-md px-3 py-2 text-sm"
                />
              </div>
            ))}

            {/* TESTIMONIAL */}
            <div className="grid grid-cols-1 sm:grid-cols-[150px_1fr] gap-4 items-start">
              <label className="text-sm font-medium text-left sm:text-right">
                Testimonial
              </label>
              <textarea
                name="testimonial"
                rows="4"
                value={form.testimonial}
                onChange={handleChange}
                className="w-full max-w-[420px] border rounded-md px-3 py-2 text-sm"
              />
            </div>

            {/* ACTIONS */}
            <div className="flex flex-col sm:flex-row justify-start sm:justify-end gap-4 pt-6 sm:pr-36">
        
              <button
                onClick={() => navigate("/uploads/testimonials")}
                className="border px-6 py-2 rounded-md text-sm"
              >
                Cancel
              </button>

              <button
                onClick={handleSubmit}
                className="bg-green-600 text-white px-6 py-2 rounded-md text-sm"
              >
                {isEdit ? "Update" : "Add"}
              </button>
            </div>
          </div>
        </div>
      </div>

    
 


    </div>
  );
}

